<template>
  <div>
    <div class="row" v-if="endpointObd2Profile && obd2Data">
      <div class="col-12">
        <div class="row" style="margin-bottom: 0px;">
          <div class="col-12" style="text-align: center;margin-top: 2em;">
            <h5 style="margin-bottom: 0px;">
              {{$t("message.Vehicle Statistics") }}
            </h5>
          </div>
        </div>
        <div class="row" style="margin-bottom: 1.5em;">
          <div class="col-12" style="text-align: center;">
            <i>{{$t("message.Last updated") }}
              {{ lastObd2UpdatedMinute }} {{minutesOrHours}} {{$t("message.ago") }} </i>
          </div>
        </div>
        <div style="height: 68vh;overflow: scroll;">
          <br />
          <div class="row" v-for="obd2Profile in endpointObd2Profile" :key="obd2Profile.name">
            <div class="col-12" style="display: flex;justify-content: center;">

              <!--             <div class="col-6" style="text-align: center;">
                  {{ obd2Profile.description }}
                </div>
                <div class="col-1" style="text-align: center;">
                  <span>-</span>
                </div>
                <div class="col-5" style="text-align: center;" v-if="endpointObd2Profile && obd2Data && obd2Data[obd2Profile.name]">
                  {{ obd2Data[obd2Profile.name] }} {{ obd2Profile.unit }}
                </div> -->
              <card class="card-stats" style="width:96%">
                <div class="statistics statistics-horizontal">
                  <div class="info info-horizontal">
                    <div class="row">
                      <div class="col-8 col-md-8 text-left pl-2">
                        <h6>{{ obd2Profile.description }}</h6>
                        <h5 v-if="endpointObd2Profile && obd2Data && obd2Data[obd2Profile.name]" style="font-weight: 500; font-size: 2em">
                          {{ obd2Data[obd2Profile.name] }} {{ obd2Profile.unit }}
                        </h5>
                      </div>
                      <div class="col-4 col-md-4 pr-0">
                        <div class="icon icon-circle" :class="`icon-info`" style="display: flex;justify-content: center;align-items: center;">
                          <img v-if="obd2Profile.icon" :src="require('@/assets/img/obd2/' + obd2Profile.icon )" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row fixed-bottom">
      <div class="col-12" style="text-align: center;">
        <n-button v-if="!btConnected && !btConnecting" type="primary" class="btn-padding mr-2" round @click.native="showBluetoothList()">
          <i slot="label" style="margin-right: 5px; position: relative;top: 2px;" class="now-ui-icons arrows-1_minimal-right"></i>
          {{$t("message.Connect to OBD2 device") }}
        </n-button>
        <n-button v-if="btConnected" type="secondary" class="btn-padding mr-2" round @click.native="disconnectFromBluetoothDevice()">
          <i style="margin-right: 5px; position: relative;top: 2px;" slot="label" class="now-ui-icons ui-1_simple-remove"></i>
          {{$t("message.Disconnect") }}
        </n-button>
      </div>
    </div>
    <modal :show.sync="showBluetoothListModel" headerClasses="justify-content-center" :showClose="false">
      <h4 slot="header" class="title title-up"> {{$t("message.Paired Bluetooth Devices") }} </h4>
      <ul style="list-style: none; padding-left: 0px;">
        <li style="font-size: 1.2em; border-bottom: solid 1px lightgrey; line-height: 2.5em;" v-for="item in bluetoothDevicesList" :key="item.id" @click="connectToBluetoothDevice(item)">
          {{ item.name }}
        </li>
      </ul>
    </modal>
  </div>
</template>

<script>
import moment from "moment-timezone";
import responsePIDS from "../../../services/obdInfo.js";
import socket from "@/services/socket";
export default {
  name: "vehiclestats",
  data() {
    return {
      lastObd2UpdatedMinute: 0,
      lastObd2UpdatedMinuteInterval: null,
      btConnecting: false,
      bluetoothDevicesList: [],
      showBluetoothListModel: false,
      connectedBluetoothDeviceName: "",
      btIntervalWriter: 0,
      minutesOrHours: "minutes",
      endpointObd2Profile: {},
    };
  },
  async mounted() {
    let that = this;
    if (this.user) {
      let user = await this.$store.dispatch("getUserById", this.user._id);

      if (user.endpoint) {
        let endpoint = await this.$store.dispatch("getEndpoint", user.endpoint);
        user.endpoint = endpoint;

        //Get obd2 profile from configurations
        let response = await this.$store.dispatch(
          "getConfigurationByEndpointId",
          {
            endpointId: endpoint._id,
            type: "obd2Profile",
          }
        );
        if (response && response.value) {
          this.endpointObd2Profile = response.value;
        }
        //Get obd2 data
        let res = await this.$store.dispatch("getObd2data", {
          endpointName: endpoint.name,
        });
        if (response && response.data) {
          this.$store.commit("setState", {
            stateName: "obd2Data",
            stateValue: res.data,
          });

          this.lastObd2UpdatedMinuteInterval = setInterval(() => {
            that.getMinutesAgo();
          }, 60000);
        }
      }

      localStorage.user = JSON.stringify(user);
      this.init_bluetooth();
    } else {
      console.log("no user");
      this.$router.push({ path: "/signin" });
    }
  },
  methods: {
    getMinutesAgo() {
      if (this.obd2Data) {
        let timestamp = moment(this.obd2Data.timestamp);
        let currentTimestamp = moment(new Date());
        this.lastObd2UpdatedMinute = currentTimestamp.diff(
          timestamp,
          "minutes"
        );
        this.minutesOrHours = "minutes";
        if (this.lastObd2UpdatedMinute > 60) {
          this.lastObd2UpdatedMinute = currentTimestamp.diff(
            timestamp,
            "hours"
          );
          this.minutesOrHours = "hours";
        }
      }
    },
    showBluetoothList() {
      let that = this;
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      bluetoothSerial.isEnabled(
        function () {
          console.log("Bluetooth is enabled");
          bluetoothSerial.list(
            function (list) {
              console.log("blue tooth list--", list);
              that.bluetoothDevicesList = list;
              that.showBluetoothListModel = true;
              loader.hide();
            },
            function (err) {
              console.log(err);
              loader.hide();
            }
          );
        },
        function () {
          console.log("Bluetooth is *not* enabled");
          loader.hide();
          swal
            .fire({
              title: this.$t("message.Bluetooth service is disabled"),
              text: this.$t("message.Would you like to enable?"),
              type: "info",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              closeOnConfirm: true,
            })
            .then((confirm) => {
              if (confirm.value) {
                bluetoothSerial.showBluetoothSettings(
                  function () {
                    console.log("Bluetooth settings opned");
                  },
                  function () {
                    console.log("Unable to open Bluetooth settings");
                  }
                );
              }
            });
        }
      );
    },
    disconnectFromBluetoothDevice() {
      let that = this;
      swal
        .fire({
          title:
            this.$t("message.Are you sure you want to disconnect from") +
            " " +
            `${this.connectedBluetoothDeviceName}?`,
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          closeOnConfirm: true,
        })
        .then((confirm) => {
          if (confirm.value) {
            bluetoothSerial.disconnect(
              function (s) {
                console.log("Bluetooth disconnected", s);
                swal.fire({
                  text:
                    this.$t("message.Disconnected from") +
                    `${that.connectedBluetoothDeviceName}!`,
                  type: "success",
                  timer: 3000,
                  title: "Success",
                });
                that.connectedBluetoothDeviceName = "";
                that.$store.commit("setState", {
                  stateName: "btConnected",
                  stateValue: false,
                });
                clearInterval(that.btIntervalWriter);
                clearInterval(that.lastObd2UpdatedMinuteInterval);
              },
              function (e) {
                console.log("Unable to disconnect from bluetooth", e);
                swal.fire({
                  text:
                    this.$t("message.Unable to disconnect from") +
                    `${that.connectedBluetoothDeviceName}!`,
                  type: "error",
                  timer: 3000,
                  title: "Error",
                });
              }
            );
          }
        });
    },
    init_bluetooth() {
      let that = this;
      bluetoothSerial.isEnabled(
        function () {
          console.log("Bluetooth is enabled");
        },
        function () {
          console.log("Bluetooth is *not* enabled");
          swal
            .fire({
              title: this.$t("message.Bluetooth service is disabled"),
              text: this.$t("message.Would you like to enable?"),
              type: "info",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              closeOnConfirm: true,
            })
            .then((confirm) => {
              if (confirm.value) {
                bluetoothSerial.showBluetoothSettings(
                  function () {
                    console.log("Bluetooth settings opned");
                  },
                  function () {
                    console.log("Unable to open Bluetooth settings");
                  }
                );
              }
            });
        }
      );
    },
    connectToBluetoothDevice(device) {
      let that = this;
      console.log("device", device);
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      that.btConnecting = true;
      that.showBluetoothListModel = false;
      bluetoothSerial.connect(
        device.id,
        (success) => {
          that.$store.commit("setState", {
            stateName: "btConnected",
            stateValue: true,
          });
          that.connstatus = "Connected";
          that.connectedBluetoothDeviceName = device.name;
          console.log("[INFO] BT Conn. Status: " + that.connstatus);
          loader.hide();
          that.btConnecting = false;
          swal.fire({
            text: `Connected to ${device.name}!`,
            type: "success",
            timer: 3000,
            title: "Success",
          });
          that.deviceConnected();
        },
        (error) => {
          that.connstatus = "Error";
          that.$store.commit("setState", {
            stateName: "btConnected",
            stateValue: false,
          });
          loader.hide();
          that.btConnecting = false;
          swal.fire({
            text: `Couldn't connect to ${device.name}!`,
            type: "error",
            timer: 3000,
            title: "Error",
          });
          that.showBluetoothListModel = false;
          console.log("[INFO] BT Conn. Status: " + that.connstatus);
        }
      );
    },
    deviceConnected() {
      bluetoothSerial.subscribe(
        "\n",
        (success) => {
          this.btDataReceived(success);
        },
        (error) => {
          console.log("[INFO] Device Connected, Subscribe error: " + error);
        }
      );
      this.init_communication();
    },
    init_communication() {
      let that = this;
      this.queue = ["ATZ", "ATL0", "ATH0", "ATE0", "ATSP0"];
      this.btIntervalWriter = setInterval(function () {
        if (that.queue.length > 0 && that.btConnected) {
          try {
            let writedata = that.queue.shift();
            bluetoothSerial.write(
              writedata + "\r",
              function (success) {
                console.log("wrote data ", success);
              },
              function (err) {
                console.log("error writing data ", err);
              }
            );
          } catch (err) {
            console.log("Error while writing: " + err);
          }
        } else {
          clearInterval(that.btIntervalWriter);
          that.getOBD2Data();
        }
      }, 150);
    },
    getOBD2Data() {
      let that = this;
      this.queue = [...this.endpointObd2Profile];
      this.btIntervalWriter = setInterval(async function () {
        if (that.queue.length > 0 && that.btConnected) {
          try {
            let writedata = that.queue.shift();
            console.log("writedata.command--", writedata.command);
            bluetoothSerial.write(
              writedata.command + "\r",
              function (success) {
                console.log("wrote data ", success);
              },
              function (err) {
                console.log("error writing data ", err);
              }
            );
          } catch (err) {
            console.log("Error while writing: " + err);
          }
        } else {
          await that.waitFor(10000);
          that.queue = [...that.endpointObd2Profile];
        }
      }, 150);
    },
    async btDataReceived(data) {
      let that = this;
      let output = data.toString("utf8");
      let parsedOutput = this.parseOBDOutput(output.split(/\r|\n/)[0]);
      if (parsedOutput.name) {
        console.log(parsedOutput);
        try {
          let name = parsedOutput.name;
          let value = parsedOutput.value;
          let res = await this.$store.dispatch("updateObd2Data", {
            data: { name: name, value: value },
            endpointName: this.user.endpoint.name,
          });
          if (res && res._id) {
            socket.emit("obd2DataUpdated", {
              endpointId: res._id,
            });
            if (res.data) {
              if (!this.obd2Data) {
                this.lastObd2UpdatedMinuteInterval = setInterval(() => {
                  that.getMinutesAgo();
                }, 60000);
              }
              that.$store.commit("setState", {
                stateName: "obd2Data",
                stateValue: res.data,
              });
              that.getMinutesAgo();
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    parseOBDOutput(hexString) {
      var reply, byteNumber, valueArray;

      reply = {};
      if (
        hexString === "NO DATA" ||
        hexString === "OK" ||
        hexString === "?" ||
        hexString === "UNABLE TO CONNECT" ||
        hexString === "SEARCHING..."
      ) {
        reply.value = hexString;
        return reply;
      }

      hexString = hexString.replace(/ /g, "");
      valueArray = [];

      for (byteNumber = 0; byteNumber < hexString.length; byteNumber += 2) {
        valueArray.push(hexString.substr(byteNumber, 2));
      }

      if (valueArray[0] === "41") {
        reply.mode = valueArray[0];
        reply.pid = valueArray[1];
        for (var i = 0; i < responsePIDS.length; i++) {
          if (responsePIDS[i].pid == reply.pid) {
            var numberOfBytes = responsePIDS[i].bytes;
            reply.name = responsePIDS[i].name;
            reply.unit = responsePIDS[i].unit || "";
            reply.description = responsePIDS[i].description || "";
            switch (numberOfBytes) {
              case 1:
                reply.value = responsePIDS[i].convertToUseful(valueArray[2]);
                break;
              case 2:
                reply.value = responsePIDS[i].convertToUseful(
                  valueArray[2],
                  valueArray[3]
                );
                break;
              case 4:
                reply.value = responsePIDS[i].convertToUseful(
                  valueArray[2],
                  valueArray[3],
                  valueArray[4],
                  valueArray[5]
                );
                break;
              case 6:
                reply.value = responsePIDS[i].convertToUseful(
                  valueArray[2],
                  valueArray[3],
                  valueArray[4],
                  valueArray[5],
                  valueArray[6],
                  valueArray[7]
                );
                break;
            }
            break;
          }
        }
      } else if (valueArray[0] === "43") {
        reply.mode = valueArray[0];
        for (var ij = 0; ij < responsePIDS.length; ij++) {
          if (responsePIDS[ij].mode == "03") {
            reply.name = responsePIDS[ij].name;
            reply.unit = responsePIDS[ij].unit || "";
            reply.description = responsePIDS[ij].description || "";
            reply.value = responsePIDS[ij].convertToUseful(
              valueArray[1],
              valueArray[2],
              valueArray[3],
              valueArray[4],
              valueArray[5],
              valueArray[6]
            );
          }
        }
      }
      return reply;
    },
    waitFor(delay) {
      return new Promise((resolve) => setTimeout(resolve, delay));
    },
  },
  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    btConnected() {
      return this.$store.state.btConnected;
    },
    obd2Data() {
      return this.$store.state.obd2Data;
    },
  },
};
</script>

<style scoped>
</style>
